import {IconButton} from 'platform/components';
import {Heading, HStack, Link, Show} from 'platform/foundation';

import {ReactElement, isValidElement} from 'react';

import {isNil, isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface PairedRecordSnippetTitleProps extends TestIdProps {
  title?: string | ReactElement;
  onOpenDetail?: () => void;
  onEdit?: () => void;
}

/**
 * Snippet title for the paired record: the entity code links to its detail and,
 * while the audit is editable, an edit button reopens the pairing dialog.
 */
export function PairedRecordSnippetTitle(props: PairedRecordSnippetTitleProps) {
  return (
    <HStack width="100%" spacing={1} align="center" justify="space-between">
      {isValidElement(props.title) ? props.title : null}
      {isNotNil(props.title) && !isValidElement(props.title) && isNotNil(props.onOpenDetail) ? (
        <Link
          size="small"
          title={props.title}
          onClick={props.onOpenDetail}
          data-testid={suffixTestId('link', props)}
        />
      ) : null}
      {isNotNil(props.title) && !isValidElement(props.title) && isNil(props.onOpenDetail) ? (
        <Heading size={5} headingLevel={6} data-testid={suffixTestId('heading', props)}>
          {props.title}
        </Heading>
      ) : null}
      <Show when={isNotNil(props.onEdit)}>
        <IconButton
          icon="image/edit"
          size="small"
          onClick={props.onEdit}
          aria-label={i18n.t('page.checklistAudits.pairing.changeCta')}
          data-testid={suffixTestId('edit', props)}
        />
      </Show>
    </HStack>
  );
}
